import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

interface IButtonPreviewImageProps {
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a button which on press switches the app from camera mode to preview
 * mode to preview the captured image.
 *
 * NOTE: This is currently hidden by default.
 */
export function ButtonPreviewImage({ onClick }: IButtonPreviewImageProps) {
  return (
    <button
      className="form-btn-secondary w-auto"
      onClick={onClick}
      type="button"
    >
      <Text text={translations.cropping.preview} />
    </button>
  );
}
